import apiClient from './api.client';

const CategoryService = {
  getByAccount: async (accountId) => {
    const res = await apiClient.get(`/menu/categories/account/${accountId}`);
    return res.data;
  },

  create: async (data) => {
    const res = await apiClient.post('/menu/categories', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await apiClient.patch(`/menu/categories/${id}`, data);
    return res.data;
  },

  remove: async (id) => {
    const res = await apiClient.delete(`/menu/categories/${id}`);
    return res.data;
  },
};

export default CategoryService;
